import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=59cdf94f&lang=pug"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=59cdf94f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,PlanCarrierLinks: require('/home/docker/code/frontend/components/PlanCarrierLinks.vue').default,Stars: require('/home/docker/code/frontend/components/Stars.vue').default,PlanProvidersList: require('/home/docker/code/frontend/components/PlanProvidersList.vue').default,PlanComparing: require('/home/docker/code/frontend/components/PlanComparing.vue').default,PlanCompare: require('/home/docker/code/frontend/components/PlanCompare.vue').default,GroupPlanCompare: require('/home/docker/code/frontend/components/GroupPlanCompare.vue').default,EnrollForm: require('/home/docker/code/frontend/components/EnrollForm.vue').default,UserGroupPlanForm: require('/home/docker/code/frontend/components/UserGroupPlanForm.vue').default,UploadFilesForm: require('/home/docker/code/frontend/components/UploadFilesForm.vue').default,EditFileForm: require('/home/docker/code/frontend/components/EditFileForm.vue').default})
